import apiFetch from '../apiFetch'

export default function (token, documentType) {
  return apiFetch({ endPoint: `DocumentType/${documentType.id}`, method: 'DELETE', body: null, token: token })
}
